
import { defineComponent } from 'vue'
import { billReApply, BillTimeoutRecordDto, getBillTimeoutList } from '@/api/pay'

export default defineComponent({
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:show', 'success'],
    data() {
        return {
            dialogVisible: false,
            loading: false,
            submitting: false,
            tableData: [] as BillTimeoutRecordDto[]
        }
    },
    watch: {
        show(newValue: boolean) {
            this.dialogVisible = newValue
        },
        dialogVisible(newValue: boolean) {
            this.$emit('update:show', newValue)
        }
    },
    methods: {
        async getList() {
            this.loading = true
            try {
                const result = await getBillTimeoutList({
                    pageNum: 1,
                    pageSize: 10000
                })
                this.tableData = result.rows || []
            } finally {
                this.loading = false
            }
        },
        formatAmount(amount: number) {
            return `￥${Number(amount || 0).toFixed(2)}`
        },
        maskIdCard(idCardNo: string) {
            if (!idCardNo) return '--'
            if (idCardNo.length <= 7) return idCardNo
            return `${idCardNo.slice(0, 3)}${'*'.repeat(idCardNo.length - 7)}${idCardNo.slice(-4)}`
        },
        getTextLength(text: string) {
            return Array.from(text || '').length
        },
        truncateProjectName(projectName: string) {
            if (!projectName) return '--'
            const characters = Array.from(projectName)
            return characters.length > 10 ? `${characters.slice(0, 10).join('')}...` : projectName
        },
        async handleConfirm() {
            if (!this.tableData.length) return
            this.submitting = true
            try {
                await billReApply({
                    ids: this.tableData.map(item => item.id)
                })
                this.$message.success('回单申请成功')
                this.dialogVisible = false
                this.$emit('success')
            } finally {
                this.submitting = false
            }
        }
    }
})
